import type { EstimateDetailResponse } from '@popety-io/types'

// An empty saved selection is intentional and must not revive older records.
const firstArray = (...values: unknown[]): unknown[] =>
  values.find((value): value is unknown[] => Array.isArray(value)) ?? []

export const getPublicEstimateEntity = (
  estimateData: Partial<EstimateDetailResponse> | null
) => {
  const edited = estimateData?.value_edited
  const val = estimateData?.value as Record<string, any> | null | undefined
  const est = val?.estimate
  const base =
    est && Object.keys(est).length > 0
      ? { ...est, id: estimateData?.id }
      : { ...val, id: estimateData?.id }
  return {
    ...base,
    noise: edited?.noise || val?.noise,
    sunlight: edited?.sunlight || val?.sunlight,
    demographics: edited?.demographics || val?.demographics,
    employment: edited?.employment || val?.employment,
    taxes: edited?.taxes || val?.taxes,
    electricity: edited?.electricity || val?.electricity,
    transport:
      edited?.transportAccess ||
      edited?.transport ||
      val?.transportAccess ||
      val?.transport,
    amenities: edited?.amenities || val?.amenities,
    market_aggregations:
      edited?.market_aggregations ||
      val?.market_aggregations ||
      (edited?.purchaseMarket || edited?.rentalMarket
        ? {
            purchase: edited?.purchaseMarket || null,
            rental: edited?.rentalMarket || null,
          }
        : null) ||
      (val?.purchaseMarket || val?.rentalMarket
        ? {
            purchase: val?.purchaseMarket || null,
            rental: val?.rentalMarket || null,
          }
        : null),
    saved_building_permits: firstArray(
      edited?.savedBuildingPermits,
      edited?.saved_building_permits,
      edited?.building_permits,
      val?.savedBuildingPermits,
      val?.saved_building_permits,
      val?.building_permits
    ),
    saved_transactions: firstArray(
      edited?.savedTransactions,
      edited?.saved_transactions,
      edited?.transactions?.transactions,
      edited?.transactions,
      val?.savedTransactions,
      val?.saved_transactions,
      val?.transactions?.transactions,
      val?.transactions
    ),
    purchase_listings: firstArray(
      edited?.savedListings,
      edited?.purchase_listings,
      edited?.purchaseListings,
      edited?.listings_comparables?.comparables,
      edited?.listings_comparables,
      val?.savedListings,
      val?.purchase_listings,
      val?.purchaseListings,
      val?.listings_comparables?.comparables,
      val?.listings_comparables
    ),
    rental_listings:
      edited?.rental_listings ||
      edited?.rentalListings ||
      val?.rental_listings ||
      val?.rentalListings ||
      [],
  }
}
